import {
  calculateVatBreakdown,
  createDefaultReceiptTemplate,
  renderReceipt,
} from '@pos/domain';

import type { SystemSettings } from '../types/domain';

const SAMPLE_SALE = {
  receiptNo: 'DASH-PREVIEW-001',
  soldAt: '2026-06-20T12:34:56.000Z',
  cashier: 'Dashboard Preview',
  subtotal: 5900,
  vatAmount: 386,
  totalAmount: 5900,
  vatRate: 7,
  payments: [{ method: 'cash' as const, amount: 5900, change: 0 }],
  lines: [
    {
      name: 'น้ำดื่มสิงห์ 600ml',
      quantity: 2,
      unitPrice: 1200,
      amount: 2400,
    },
    {
      name: 'มาม่าหมูสับ',
      quantity: 5,
      unitPrice: 700,
      amount: 3500,
    },
  ],
};

export function ReceiptPreview({ s }: { s: SystemSettings }) {
  const grossAmount = SAMPLE_SALE.lines.reduce(
    (sum, line) => sum + line.amount,
    0,
  );
  const breakdown = calculateVatBreakdown(
    grossAmount,
    s.vatRate * 100,
    s.vatInclusive,
  );
  const template = createDefaultReceiptTemplate({
    shopName: s.shopName,
    shopCode: s.shopCode,
    taxId: s.taxId,
    branchName: '{BRANCH_NAME}',
    settings: {
      receiptHeader: s.receiptHeader,
      receiptFooter: s.receiptFooter,
    },
    includeRounding: false,
  });
  const rendered = renderReceipt({
    template,
    sale: {
      ...SAMPLE_SALE,
      subtotal: breakdown.netAmount,
      vatAmount: breakdown.vatAmount,
      totalAmount: breakdown.grossAmount,
      vatRate: s.vatRate,
      payments: [
        {
          method: 'cash' as const,
          amount: breakdown.grossAmount,
          change: 0,
        },
      ],
    },
  });

  return (
    <div className="w-[384px] bg-white border border-line rounded-card p-4 text-[12px] text-ink shadow-sm">
      <pre className="font-mono whitespace-pre-wrap leading-relaxed">
        {rendered.content}
      </pre>
    </div>
  );
}
